/**
 * Short Words Pack - 5-6 letter words
 * Combines words-5.ts and words-6.ts for quick gameplay
 */

import { WordPack } from '../../types/GameTypes';
import words5 from '../words-5';
import words6 from '../words-6';

const shortWordsPack: WordPack = {
  id: 'short-words',
  name: 'Short Words (5-6 Letters)',
  description: 'Quick games with shorter words - perfect for fast-paced play',
  difficulty: 'easy',
  words: [...words5, ...words6]
};

export default shortWordsPack;